import { defineComponent as s, createElementBlock as a, openBlock as t, normalizeClass as l, Fragment as c, renderList as m, createBlock as i, createCommentVNode as u, resolveDynamicComponent as d, toRaw as b } from "vue";
import { scrollToElement as y } from "../../../utils/scrollToElement.js";
const C = ["aria-labelledby"], w = /* @__PURE__ */ s({
  name: "RevCardCarouselItems",
  __name: "CardCarouselItems",
  props: {
    cardClasses: { type: [String, Boolean, Array, Object] },
    items: {},
    center: { type: Boolean },
    ariaLabelledby: {}
  },
  setup(e) {
    const o = () => {
      y(document.activeElement, {
        timeout: 50,
        scroll: { behavior: "smooth", block: "nearest", inline: "center" }
      });
    };
    return (f, p) => (t(), a("ul", {
      "aria-labelledby": e.ariaLabelledby,
      class: l(["pb-20 grid grid-flow-col auto-rows-max grid-rows-1 gap-8 md:gap-16", e.center ? "w-full justify-center-safe" : "w-max"])
    }, [
      (t(!0), a(c, null, m(e.items, (r, n) => (t(), a("li", {
        key: n,
        class: l(["snap-start list-none", e.cardClasses])
      }, [
        r ? (t(), i(d(b(r)), {
          key: 0,
          onFocus: o
        }, null, 32)) : u("", !0)
      ], 2))), 128))
    ], 10, C));
  }
});
export {
  w as default
};
